import './CensusErrorDataManyStep.scss';
import { useTranslation } from 'react-i18next';

import BannerFill from '../../../../../../../../../shared/components/Globals/BannerFill/BannerFill';
import type { IQuickCensusError } from '../../../../../../../../../shared/interfaces/quotes';
import { TRANSLATIONS_QUOTES } from '../../../../../../../../../shared/translations/quotes';

export interface CensusErrorDataManyStepProps {
  errors: IQuickCensusError[];
}

export default function CensusErrorDataManyStep({ errors }: Readonly<CensusErrorDataManyStepProps>) {
  const { t } = useTranslation();

  const uniqueRowsCount = new Set(errors.map((e) => e.row)).size;

  const groupedErrors = errors.reduce(
    (acc, err) => {
      const key = err.message || '';
      if (!acc[key]) {
        acc[key] = {
          message: err.message,
          count: 0
        };
      }
      acc[key].count += 1;
      return acc;
    },
    {} as Record<string, { message: string; count: number }>
  );

  const groupedList = Object.values(groupedErrors);

  return (
    <div className="census-step">
      <BannerFill
        variant="danger"
        inline
        title={t(TRANSLATIONS_QUOTES.create.censusModal.errorManyBannerTitle, { count: uniqueRowsCount })}
        screenReaderLabel={t(TRANSLATIONS_QUOTES.create.censusModal.error)}
      />

      <div className="census-error-summary">
        <div className="census-error-summary__label">{t(TRANSLATIONS_QUOTES.create.censusModal.errorSummary)}</div>
        <div className="census-error-summary__list">
          {groupedList.map((group) => (
            <div key={group.message} className="census-error-summary__item">
              <span className="census-error-summary__bullet">·</span> {group.message}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
